import { onMounted, onBeforeUnmount } from 'vue';

const KONAMI_SEQUENCE = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'KeyB', 'KeyA'];

/**
 * Registers a global keydown listener for the Konami code (↑↑↓↓←→←→BA).
 * On success calls onSuccess once and stops listening until the composable is used again.
 */
export function useKonamiCode (onSuccess: () => void): void {
    let index = 0;

    function handleKeydown (e: KeyboardEvent): void {
        if (e.code === KONAMI_SEQUENCE[index]) {
            index += 1;
            if (index === KONAMI_SEQUENCE.length) {
                index = 0;
                window.removeEventListener('keydown', handleKeydown);
                onSuccess();
            }
        } else {
            index = 0;
        }
    }

    onMounted(() => {
        window.addEventListener('keydown', handleKeydown);
        // eslint-disable-next-line no-console
        console.log(
            '%cHint: for an easter egg, try %c↑ ↑ ↓ ↓ ← → ← → B A',
            'color: #666; font-size: 14px;',
            'color: #f39200; font-weight: bold; font-size: 14px;',
        );
    });

    onBeforeUnmount(() => {
        window.removeEventListener('keydown', handleKeydown);
    });
}
